import Axios, { InternalAxiosRequestConfig } from 'axios'

import { HOST, NAV_LINKS } from '~/constants'

import { clearTokens, getAccessToken, getRefreshToken, setTokens } from './auth-tokens'

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json'
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  config.withCredentials = false
  return config
}

export const api = Axios.create({
  baseURL: HOST,
})

let isRefreshing = false
let failedQueue: any[] = []

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

api.interceptors.request.use(authRequestInterceptor)
api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (!originalRequest || originalRequest.url?.includes('/oauth/token')) {
      return Promise.reject(error)
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject })
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token
            return api(originalRequest)
          })
          .catch((err) => Promise.reject(err))
      }

      originalRequest._retry = true
      isRefreshing = true
      try {
        const refreshToken = getRefreshToken()
        if (!refreshToken) throw error

        const res = await api.post('/oauth/token', {
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        })
        setTokens(res.data.access_token, res.data.refresh_token)
        api.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.access_token
        processQueue(null, res.data.access_token)
        originalRequest.headers['Authorization'] = 'Bearer ' + res.data.access_token
        return api(originalRequest)
      } catch (err) {
        processQueue(err, null)
        clearTokens()
        window.location.href = NAV_LINKS.SIGNIN.to
        return Promise.reject(err)
      } finally {
        isRefreshing = false
      }
    }
    return Promise.reject(error)
  }
)
